/**
 * ProtectedRoute Component
 * Checks RBAC permissions before rendering route components
 */

import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({
  path,
  element,
  routeData,
  requiredPermission
}) => {
  const hasPermission = React.useMemo(() => {
    const result = (() => {
      if (!routeData) return { allowed: false, reason: 'routeData is null/undefined' };
      // rbacEnabled: false → not controlled by RBAC, always allow
      if (routeData.rbacEnabled === false) return { allowed: true, reason: 'rbacEnabled=false (bypass RBAC)' };
      // rbacEnabled: true → check allowed flag
      if (routeData.allowed) return { allowed: true, reason: `allowed=${routeData.allowed}` };
      return { allowed: false, reason: `allowed=${routeData.allowed}, rbacEnabled=${routeData.rbacEnabled}` };
    })();

    console.log(`[ProtectedRoute] path="${path}" | permission="${requiredPermission}" | ${result.allowed ? '✅ ALLOWED' : '❌ BLOCKED'} | reason: ${result.reason}`, routeData ? { allowed: routeData.allowed, rbacEnabled: routeData.rbacEnabled, name: routeData.name } : 'NO_ROUTE_DATA');

    return result.allowed;
  }, [routeData, path, requiredPermission]);

  if (!hasPermission) {
    return <Navigate to="/errors/403" replace state={{ attemptedPath: path }} />;
  }

  return element;
};

export default ProtectedRoute;
